import ApiUrls from '@api/apiUrls';
import { fetchApi, FetchApiResponse } from '@api/fetchApi';
import {
  IBaseAccountSettings,
  IInvestorSettingsRequest,
  IMasterSettingsRequest,
} from '@api/services/user/copyTrading/userCopyTrading.apiService.interfaces';

export const apiUserCopyTrading = {
  getMasterSettings: async (request: IMasterSettingsRequest): Promise<FetchApiResponse<IBaseAccountSettings>> => {
    return await fetchApi.post<IBaseAccountSettings>(ApiUrls.copyTradingSettings.getForMaster, request);
  },

  getInvestorSettings: async (request: IInvestorSettingsRequest): Promise<FetchApiResponse<IBaseAccountSettings>> => {
    return await fetchApi.post<IBaseAccountSettings>(ApiUrls.copyTradingSettings.getForInvestor, {
      investorId: request.investorId,
      masterId: request.masterAccountId,
    });
  },
};
